import { ErrorBoundary as RaveErrorBoundary } from "@magalu/rave/errorBoundary";
import { useRouter } from "@magalu/rave/router";
import { usePlatformHooks } from "@magalu/ravejs-platform-hooks";
import { PropsWithChildren } from "react";

export const ErrorBoundary = ({ children }: PropsWithChildren) => {
  const { useErrorScreen } = usePlatformHooks();
  const router = useRouter();

  const appOnError = (e: Error, errorInfo: React.ErrorInfo) => {
    // TODO: add track for errors
    console.error(e);
    console.error(errorInfo);
  };

  const handleRedirectErrorBoundary = () => {
    useErrorScreen({
      fallback: () => {
        router.replace("/500/");
      },
    });
    return null;
  };

  return (
    <RaveErrorBoundary
      onError={appOnError}
      redirectTo={handleRedirectErrorBoundary}
    >
      {children}
    </RaveErrorBoundary>
  );
};
